import { render } from "./BatterTrainView.vue?vue&type=template&id=a89f76f6&scoped=true"
import script from "./BatterTrainView.vue?vue&type=script&lang=js"
export * from "./BatterTrainView.vue?vue&type=script&lang=js"

import "./BatterTrainView.vue?vue&type=style&index=0&id=a89f76f6&lang=scss&scoped=true"

import exportComponent from "/Users/icesea/WebstormProjects/fpcs-h5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a89f76f6"]])

export default __exports__